import { useMemo } from "react";
import { TooltipEllipsisTableCellProps } from "./types";
import { TableCell, TableCellLayout } from "@fluentui/react-components";
import { useTableStyle } from "@/components/atoms/customTable";
import TooltipWithMount from "@/components/atoms/tooltipWithMount/TooltipWithMount";
import { useStyle } from "./style";

export const TooltipEllipsisTableCell = (
    props: TooltipEllipsisTableCellProps
) => {
    const { text, component, title, tableCellStyle, suffixIcon } = props;
    const tableClasses = useTableStyle();
    const classes = useStyle();

    const tooltipContent = text ?? title ?? "";

    const cellContent = useMemo(() => {
        if (suffixIcon) {
            return (
                <div className={classes.suffixContainer}>
                    <TooltipWithMount
                        withArrow
                        positioning={"below"}
                        content={{
                            children: tooltipContent,
                            className: tableClasses.tooltip,
                        }}
                        relationship="label"
                    >
                        <div className={classes.textWrapper}>
                            <span className={tableClasses.ellipsis}>
                                {text}
                            </span>
                            {component}
                        </div>
                    </TooltipWithMount>
                    <div className={classes.iconWrapper}>{suffixIcon}</div>
                </div>
            );
        }

        return (
            <TooltipWithMount
                withArrow
                positioning={"below"}
                content={{
                    children: tooltipContent,
                    className: tableClasses.tooltip,
                }}
                relationship="label"
            >
                <TableCellLayout truncate>
                    {text && (
                        <span className={tableClasses.ellipsis}>{text}</span>
                    )}
                    {component}
                </TableCellLayout>
            </TooltipWithMount>
        );
    }, [
        suffixIcon,
        text,
        component,
        tooltipContent,
        classes,
        tableClasses,
    ]);

    return (
        <TableCell style={tableCellStyle} key={props.columnId}>
            {cellContent}
        </TableCell>
    );
};